import { useQuery } from '@tanstack/react-query';
import { leadsService } from '../services';

/**
 * Hook para buscar lead específico por ID
 *
 * @param id - ID do lead
 * @returns Query result com dados do lead
 *
 * @example
 * ```tsx
 * const { data: lead, isLoading } = useLeadById('lead-id-123');
 * ```
 */
export const useLeadById = (id?: string) => {
  return useQuery({
    queryKey: ['lead', id],
    queryFn: () => leadsService.getLeadById(id!),
    enabled: !!id,
    staleTime: 60 * 1000, // 1 minute
  });
};
